export default {
	GET_WORK_ORDER: state => state.workOrder,
	GET_GST_DATA: state => state.GSTData,
}